import { LoadingOrderlines } from "@/types/LoadingOrderline";
import Order from "@/types/Order";
import Orderline from "@/types/Orderline";
import axios from "axios";
import { isString, result } from "lodash";
import { defineStore } from "pinia";

export const useStore = defineStore("order", {
  state: () => {
    return {
      order: null as Order | null,
      order_id: 0,
      orderlines: [] as Orderline[],
      loadingOrderlines: [] as LoadingOrderlines[],
      openElsewhere: false,
      openLocation: "other-registry",
      paymentProcessing: false,
      broadcastChannel: null as null | BroadcastChannel,
      actionsLocked: false,
    };
  },
  getters: {
    totalExMva: (state): number => {
      let price = 0;

      state.orderlines.forEach((orderline) => {
        price += orderline.amount * orderline.price_out;
      });

      return price;
    },
    totalIncMva: (state): number => {
      let price = 0;

      state.orderlines.forEach((orderline) => {
        console.log({
          orderline: orderline.product.name,
          price: parseFloat(
            (orderline.amount * orderline.price_out_with_mva).toFixed(2)
          ),
        });
        price += parseFloat(
          (orderline.amount * orderline.price_out_with_mva).toFixed(2)
        );
      });

      price = parseFloat(price.toFixed(2));

      return Math.round(price);
    },
    mvaAmount(): number {
      return this.totalIncMva - this.totalExMva;
    },
    isPayed: (state): boolean => {
      if (state.order?.paid) {
        return true;
      }

      if (state.order?.invoice?.paid) {
        return true;
      }

      return false;
    },
    isInvoiced: (state): boolean => {
      return state.order?.invoice !== null;
    },
    isClosed: (state): boolean => {
      return state.order?.closed !== null;
    },
    isEditable(state): boolean {
      return !state.openElsewhere && !this.isClosed && !this.isPayed;
    },
    isWeborder(state): boolean {
      return state.order?.weborder === true;
    },
  },
  actions: {
    openOrder(isOpenByOthers: boolean) {
      if (isOpenByOthers) {
        this.openElsewhere = true;
        return;
      }

      this.broadcastChannel = new BroadcastChannel(`order.${this.order_id}`);

      this.broadcastChannel.onmessage = (event) => {
        if (!this.broadcastChannel || this.openElsewhere) {
          return;
        }

        console.log(`New message: ${event.data}`);

        if (event.data === "requestOpenOrder") {
          this.broadcastChannel.postMessage("taken");
        }

        if (event.data === "taken") {
          this.openElsewhere = true;
          this.openLocation = "other-tab";
        }
      };

      this.broadcastChannel.postMessage("requestOpenOrder");
    },
    closeOrder() {
      this.broadcastChannel?.close();
    },
    switchOrder(newOrder: Order, isOpenByOthers: boolean) {
      this.order = newOrder;
      this.order_id = newOrder.id;
      this.orderlines = newOrder.orderlines;

      this.broadcastChannel?.close();

      this.openOrder(isOpenByOthers);
    },
    setPaymentProcessing(value: boolean) {
      this.paymentProcessing = value;
    },
    findIndexInLoadingLines(barcode: string) {
      return this.loadingOrderlines.findIndex((value) => {
        if (value.barcode === barcode) {
          return true;
        }

        return false;
      });
    },
    addToLoadingLines(barcode: string) {
      if (this.findIndexInLoadingLines(barcode) === -1) {
        this.loadingOrderlines.push({
          barcode,
        });
      }
    },
    removeFromLoadingLines(barcode: string) {
      const index = this.findIndexInLoadingLines(barcode);

      if (index !== -1) {
        this.loadingOrderlines.splice(index, 1);
      }
    },
    errorInLoadingLine(barcode: string, error: string) {
      const index = this.findIndexInLoadingLines(barcode);

      if (index !== -1) {
        this.loadingOrderlines[index].error = error;
      }
    },
    async addProductFromBarcode(barcode: string, quantity: number) {
      return new Promise(async (resolve, reject) => {
        this.addToLoadingLines(barcode);

        axios
          .post(route("orders.orderlines.store", { order: this.order_id }), {
            barcode: barcode,
            amount: quantity,
          })
          .then((result) => {
            const orderlines: Orderline[] = result.data;

            console.log(orderlines);

            orderlines.forEach(orderline => {
              console.log({orderlineBar: orderline});

              const existing = this.orderlines.findIndex((value) => {
                if (value.id === orderline.id) {
                  return true;
                }

                return false;
              });

              if (existing !== -1) {
                this.orderlines[existing] = orderline;
              } else {
                this.orderlines.push(orderline);
              }

              this.removeFromLoadingLines(barcode);
            });

            resolve(orderlines);
          })
          .catch((error) => {
            const response = error.response;

            let message = "";
            if (response.status === 404) {
              message =
                "Skannet produkt finnes ikke eller er ikke lagt inn med strekkode.";
            } else if (response.data.message) {
              message = response.data.message;
            } else {
              message = "Noe gikk galt ved skanning";
            }

            this.errorInLoadingLine(barcode, message);

            setTimeout(() => {
              this.removeFromLoadingLines(barcode);
            }, 20000);

            reject(error);
          });
      });
    },
    async scanProduct(barcode: string, quantity: number, action:string) {
      console.log({barcode, quantity, order: this.order_id })
      return new Promise(async (resolve, reject) => {

        axios
          .post(route("orderline.scan", { order: this.order_id }), {
            barcode: barcode,
            amount: quantity,
            action
          })
          .then((result) => {
            //const orderlines: Orderline[] = result.data;
            if(result.data?.type === "MSG"){
              this.addToLoadingLines(barcode)
              this.errorInLoadingLine(barcode, result.data?.message);

              setTimeout(() => {
                this.removeFromLoadingLines(barcode);
              }, 5000);
              resolve([]);

            }
            if(result.data?.type === "RELOAD"){
              this.orderlines = result.data.orderlines
            }



            resolve([]);
          })
          .catch((error) => {
            const response = error.response;
            console.log(error)

            let message = "";
            if (response.status && response.status === 404) {
              message =
                "Skannet produkt finnes ikke eller er ikke lagt inn med strekkode.";
            } else if (response.data.message) {
              message = response.data.message;
            } else {
              message = "Noe gikk galt ved skanning";
            }

            this.errorInLoadingLine(barcode, message);

            setTimeout(() => {
              this.removeFromLoadingLines(barcode);
            }, 20000);

            reject(error);
          });
      });
    },
    async scanKGProduct(product_id: number,quantity: number, action:string) {
      return new Promise(async (resolve, reject) => {

        axios
          .post(route("orderline.scan-kg", { order: this.order_id }), {
            product_id: product_id,
            amount: quantity,
            action
          })
          .then((result) => {
            //const orderlines: Orderline[] = result.data;
            if(result.data?.type === "MSG"){
              this.addToLoadingLines("product_" + product_id)
              this.errorInLoadingLine("product_" + product_id, result.data?.message);

              setTimeout(() => {
                this.removeFromLoadingLines("product_" + product_id);
              }, 5000);
              resolve([]);

            }
            if(result.data?.type === "RELOAD"){
              this.orderlines = result.data.orderlines
            }



            resolve([]);
          })
          .catch((error) => {
            const response = error.response;
            console.log(error)

            let message = "";
            if (response.status && response.status === 404) {
              message =
                "Produkt finnes ikke";
            } else if (response.data.message) {
              message = response.data.message;
            } else {
              message = "Noe gikk galt ved skanning";
            }

            this.errorInLoadingLine("product_" + product_id, message);

            setTimeout(() => {
              this.removeFromLoadingLines("product_" + product_id);
            }, 20000);

            reject(error);
          });
      });
    },
  },
});
